import type { EccLevel } from '@qwerty/engine/qr/qr_encode';
import type { ParallelQRCount } from '@qwerty/engine/sender/parallel_striping';

export interface AppSettings {
  version: number;
  ecc: EccLevel;
  parallel: ParallelQRCount;
  fps: number;
  repairPercent: number;
  compress: boolean;
}

export const DEFAULT_SETTINGS: AppSettings = {
  version: 20,
  ecc: 'L',
  parallel: 4,
  fps: 30,
  repairPercent: 10,
  compress: true,
};

const KEY = 'qwerty.settings.v1';

export function loadSettings(): AppSettings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<AppSettings>;
    return { ...DEFAULT_SETTINGS, ...parsed };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings: AppSettings): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(settings));
  } catch {
    // storage unavailable — ignore
  }
}
